import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Assignee } from 'src/app/api/assignee.service';
import { OnAssignValues } from '../../assign-incident/assign-incident.component';

@Component({
    selector: 'app-assign-incident-modal',
    templateUrl: './assign-incident-modal.component.html',
    styleUrls: ['./assign-incident-modal.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignIncidentModalComponent implements OnInit {



 incidentId: number = -1

  constructor(
    public modalRef: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    if (!config.data.incidentId) throw new Error("Incident ID must be provided to Assign Modal");
    this.incidentId = config.data.incidentId
   }



  ngOnInit(): void {
  }

  onAssign(result: OnAssignValues) {
   this.modalRef.close(result)

  }

}
